import { io, Socket } from "socket.io-client";
import { config } from "../../config";

// ----------------------------- Base Urls ----------------------------------
const SOCKET_SERVER_URL = config.api.socketUrl

export const initializeSocket = (user_uuid: string): Socket => {
  const app_socket = io(SOCKET_SERVER_URL, {
    autoConnect: false, // Prevent automatic connection
    auth: {
      user_uuid, // Send user_uuid uuid
    },
  });
  app_socket.connect();
  return app_socket;
};


export const isValidOutlet = (uuid: string | undefined | null): boolean => {
  return !!uuid && uuid.trim() !== "";
};
